<template>
  <div class="box_ul">
  <div class="box_title">最佳成绩</div>
      <div class="box_li">
          <div class="up">
            {{ scoreKnow.testTime }}
            <span class="knowscore" >
            当前成绩
            </span>          
          </div>
        <van-row>

        <van-col span="6">
            <span class="num two" v-if="scoreKnow.projectCode === 'HeightWeight'"  style="font-size: 3.8vw;">
                  <div v-if="scoreKnow.score=='免测'">免测</div>
                  <div v-else>
                    <div>{{scoreKnow.scoreOriginal}}</div>
                    <div><span>{{scoreKnow.score}}KG/</span><span>{{scoreKnow.remarkScore}}M</span></div>
                  </div>
              </span>
              <div class="num" v-else>{{ scoreKnow.score }}</div>
              <div class="text">测试成绩</div>
        </van-col>
        <van-col span="6">
          <div class="num">{{ scoreKnow.fraction }}</div>
          <div class="text">测试得分</div>
        </van-col>
        <van-col span="7">
          <div class="num" :style="{ color: level[scoreKnow.level] }">{{ scoreKnow.level }}</div>
          <div class="text">等级</div>
        </van-col>
        <van-col span="5" class="dfcenter">
             <VideoDialog :url='scoreKnow.videoPath'>
            <template slot="icon">
            <div style="color:#4B88E0;" >
            <div>视频回看</div>
            </div>
            </template>
              </VideoDialog>
          
        </van-col>
      </van-row>
      </div>





    <div>
    


  
  
      <ul v-if="scoreList.length>0" class="box_ul">
        <div  class="box_title">测试记录</div>


  <div v-for="item in scoreList" :key="item.id" class="box_li">
          <div class="up">
            {{ scoreKnow.testTime }}
          </div>
        <van-row>

        <van-col span="5">
            <span class="num1" v-if="scoreKnow.projectCode === 'HeightWeight'" style="font-size: 3.5vw;">
                  <div v-if="scoreKnow.score=='免测'">免测</div>
                  <div v-else>
                    <div>{{scoreKnow.scoreOriginal}}</div>
                    <div><span>{{scoreKnow.score}}KG/</span><span>{{scoreKnow.remarkScore}}M</span></div>
                  </div>
              </span>
              <div class="num1"  v-else>{{ scoreKnow.score }}</div>
              <div class="text">测试成绩</div>
        </van-col>
        <van-col span="5">
          <div class="num1">{{ scoreKnow.fraction }}</div>
          <div class="text">测试得分</div>
        </van-col>
        <van-col span="5">
          <div class="num1" :style="{ color: level[scoreKnow.level] }">{{ scoreKnow.level }}</div>
          <div class="text">等级</div>
        </van-col>
        <van-col span="4" />

        <van-col span="5" style="">
             <VideoDialog :url='scoreKnow.videoPath'>
            <template slot="icon">
            <div style="color:#4B88E0;" >
            <div>视频回看</div>
            </div>
            </template>
              </VideoDialog>
          
        </van-col>
      </van-row>
      </div>


      </ul>
        <van-empty
        v-else
        image-size="80"
        description="暂无测试成绩"
      />
    </div>
    <van-dialog v-model="handleVisible" class="model-box">
      <div>遇到人脸二次认证不通过问题，请重新测试并注意:</div>
      <p>1、如果人脸照片质量不高。请重新在公众号拍照提交</p>
      <p>2、人脸认证时保证面部在识别区内</p>
      <p>3、测试时确保才是区域只有本人</p>
      <div>如果按照上述行为依然提示该问题，请<span @click="goNext(itemInfo)">点击此处</span>申诉</div>
    </van-dialog>
 
   
  
  </div>
</template>

<script>
import { getProjectScoreList } from '@/api/resultReporting'
import moment from 'moment'
import VideoDialog from '@/components/VideoDialog.vue'

export default {
  name: 'singleItemAchievement',
  components: {
    VideoDialog
  },
  data () {
    return {
      userInfo: {},
      scoreList: [],
      visible: false,
      appeal: ['', '申诉中', '申诉成功', '申诉驳回'],
      auditStatus: ['审核中', '审核通过', '驳回'],
      
      level: {
        优秀: '#33cb57',
        良好: '#3460e7',
        及格: '#f18424',
        不及格: '#ff284b'
      },
      auditStatusColor: [
        { backgroundColor: '#f18424' },
        { backgroundColor: '#3dc414' },
        { backgroundColor: '#ff284b' }
      ],
      status: [
        { backgroundColor: 'unset' },
        { backgroundColor: '#f18424' },
        { backgroundColor: '#3460e7' },
        { backgroundColor: '#ff284b' }
      ],
      currentDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        17
      ),
      maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 17),
      minDate: new Date(new Date().getFullYear() - 6, 0),
      chooseMonthDate: this.$route.query.testTime ? this.$route.query.testTime.slice(0, 7): null,
      handleVisible: false,
      itemInfo: null,
      clickData:{},
      scoreKnow:{}
    }
  },
  created () {
    this.getProjectScoreList()
  },
  methods: {
    goNext (item) {
      if (item) {
        this.clickData = item
        // this.$router.push({
        //   path: '/singleItemDetail',
        //   query: { item: JSON.stringify(item) }
        // })
      }
    },
    gethandle(item){
      this.itemInfo = item
      this.handleVisible = true
    },
    monthChoose (value) {
      this.currentDate = value
      this.chooseMonthDate = moment(value).format('YYYY-MM')
      this.visible = false
      this.getProjectScoreList()
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },

 getProjectScoreList(){
    getProjectScoreList({
      
      snCode:this.$route.query.snCode,
      schoolCode:this.$route.query.schoolCode,
      projectCode:this.$route.query.projectCode,
      
     }).then(res=>{
      res.data.data?.forEach(el=>{
        
        // el.videoPath = 'http://121.199.48.84:7000'  +el.videoPath
        // el.videoPath = 'https://' + window.location.host +el.videoPath
        // console.log(el.videoPath );
       switch(el.projectName) {
                case '肺活量': return el.unit= '（毫升）'
                case '坐位体前屈': return el.unit= '（厘米）'
                case '立定跳远': return el.unit= '（厘米）'
                case '仰卧起坐': return el.unit= '（个）'
                case '50*8往返跑': return el.unit= '（秒）'
                case '跳绳': return el.unit= '（个）'
                case '体重': return el.unit= '（千克）'
                case '身高': return el.unit= '（厘米）'
                case '50米': return el.unit= '（秒）'
                default: return el.unit= ''
                }
      })
      this.scoreList = res.data.data||[]
      this.scoreKnow = res.data.body
    
     })
  },

  }
}
</script>

<style lang="less" scoped>
.box_title{
  color: #3D3D3D;
  font-size: 4vw;
  font-weight: normal;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.box_ul{

  .box_li{
  background-color: #fff;
  padding: 10px;
  font-size: 3vw;
  border-bottom: 1px solid #f5f5f5;
  .up{
    margin: 5px 0;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 15px;
      .knowscore{
       background-color: #EDF2FF;
      color: #216DD9;
      padding: 3px;
       border-radius: 10px;
  }
  }
  
    .num{
      font-size: 5vw;
      text-align: center;
      margin-bottom: 5px;

    }
    .num1{
      font-size: 4vw;
      text-align: center;
      margin-bottom: 5px;
    }
    .text{
      text-align: center;
      font-size: 3vw;

    color: rgba(0, 0, 0, 0.4);

    }



  }
 
}





</style>
